.c9{flex-shrink:0;}